import React from 'react';

import { FourriereViolationDtoFormFieldEnum } from 'lib_api/lib/api/gen';

import { useApi } from 'hooks/ApiStoreContext';
import { useSubmitReferentielForm } from 'hooks/referentiels/useSubmitReferentielForm';
import { useValidateReferentielForm } from 'hooks/referentiels/useValidateReferentielForm';
import { FourriereFormValues } from 'types/referentiels/Fourriere';

import { buildRequestDto } from '../utils';

import ModalEditionFourriere from './ModalEditionFourriere';

interface ModalCreateProps {
  close: () => void;
  visible: boolean;
  refreshDashboard: () => void;
}

export default function ModalCreate({
  close,
  visible,
  refreshDashboard,
}: ModalCreateProps): React.ReactElement {
  const initials: FourriereFormValues = {};
  const { AdminFonctionnelControllerApi } = useApi();
  const { submit, inProgress } = useSubmitReferentielForm(
    refreshDashboard,
    close,
    (values: FourriereFormValues) =>
      AdminFonctionnelControllerApi.createFourriereUsingPOST(
        buildRequestDto(values),
      ),
  );
  const { validate } = useValidateReferentielForm(
    (field: FourriereViolationDtoFormFieldEnum, values: FourriereFormValues) =>
      AdminFonctionnelControllerApi.validateCreateFourriereFieldUsingPOST(
        field,
        buildRequestDto(values),
      ),
    response => response.fourriereViolationsDto ?? [],
  );

  return (
    <ModalEditionFourriere
      close={close}
      visible={visible}
      title="Créer une fourrière"
      initials={initials}
      isSubmitting={inProgress}
      submit={submit}
      validate={validate}
    />
  );
}
